export class User {
    constructor(name, id, avatar, level) {
        this.tablePosition = -1;
        this.game = undefined;
        this.name = name;
        this.id = id;
        if (!id) {
            this.id = Math.floor(Math.random() * 1000000);
        }
        this.avatar = avatar;
        this.level = level;
    }
    onMessage(eventName, ...args) {
        console.log(`User:${this.level}.onMessage:`, eventName, args);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvdXNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLE9BQU8sSUFBSTtJQU9oQixZQUFZLElBQVksRUFBRSxFQUFVLEVBQUUsTUFBYyxFQUFFLEtBQWE7UUFGNUQsa0JBQWEsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUNuQixTQUFJLEdBQVUsU0FBUyxDQUFDO1FBRTlCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO1FBRWIsSUFBSSxDQUFDLEVBQUUsRUFBRTtZQUNSLElBQUksQ0FBQyxFQUFFLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDLENBQUM7U0FDOUM7UUFFRCxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztRQUNyQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNwQixDQUFDO0lBRU0sU0FBUyxDQUFDLFNBQWlCLEVBQUUsR0FBRyxJQUFXO1FBQ2pELE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxJQUFJLENBQUMsS0FBSyxhQUFhLEVBQUUsU0FBUyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQy9ELENBQUM7Q0FDRCJ9